import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

/////////////////////////////////////////////////////////////////////
// List of groups load

export interface ListOfGroupsFetchApiAction extends Action {
    readonly query: string;
    readonly category: string;
    readonly limitNew: number;
    readonly after: number;
}

export const FORUM_LIST_OF_GROUPS_FETCH_API_REQUEST = 'FORUM_LIST_OF_GROUPS_FETCH_API_REQUEST';

export interface ListOfGroupsFetchApiRequestAction extends ListOfGroupsFetchApiAction, APIRequestAction {
    readonly type: typeof FORUM_LIST_OF_GROUPS_FETCH_API_REQUEST;
}

export const FORUM_LIST_OF_GROUPS_FETCH_API_SUCCESS = 'FORUM_LIST_OF_GROUPS_FETCH_API_SUCCESS';

export interface ListOfGroupsFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        readonly groups: number[];
        readonly newGroups: number[];
    };
}

export interface ListOfGroupsFetchApiSuccessAction extends ListOfGroupsFetchApiAction, APISuccessAction<ListOfGroupsFetchNormalizedResponse> {
    readonly type: typeof FORUM_LIST_OF_GROUPS_FETCH_API_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
    readonly count: number;
    readonly memberships: number[];
    readonly askedToJoin: number[];
    readonly favorites: number[];
}

export const FORUM_LIST_OF_GROUPS_FETCH_API_FAILURE = 'FORUM_LIST_OF_GROUPS_FETCH_API_FAILURE';

export interface ListOfGroupsFetchApiFailureAction extends ListOfGroupsFetchApiAction, APIFailureAction {
    readonly type: typeof FORUM_LIST_OF_GROUPS_FETCH_API_FAILURE;
}

export const listOfGroupsFetchApi = {
    request: (category: string, query: string, limitNew: number, after: number): ListOfGroupsFetchApiRequestAction => ({
        type: FORUM_LIST_OF_GROUPS_FETCH_API_REQUEST,
        category, query, limitNew, after,
    }),
    success: (category: string, query: string, count: number, memberships: number[], askedToJoin: number[], favorites: number[], limitNew: number, after: number, hasNext: number, hasPrevious: number, response: any): ListOfGroupsFetchApiSuccessAction => ({
        type: FORUM_LIST_OF_GROUPS_FETCH_API_SUCCESS,
        category, query, count, memberships, askedToJoin, favorites, limitNew, after, hasNext, hasPrevious,
        response,
    }),
    failure: (category: string, query: string, limitNew: number, after: number, error: any): ListOfGroupsFetchApiFailureAction => ({
        type: FORUM_LIST_OF_GROUPS_FETCH_API_FAILURE,
        category, query, limitNew, after,
        error,
    }),
};

export const FORUM_LIST_OF_GROUPS_LOAD = 'FORUM_LIST_OF_GROUPS_LOAD';

export interface ListOfGroupsLoadAction extends ListOfGroupsFetchApiAction {
    readonly type: typeof FORUM_LIST_OF_GROUPS_LOAD;
}

export const listOfGroupsLoad = (category: string, query: string, limitNew: number, after: number): ListOfGroupsLoadAction => ({
    type: FORUM_LIST_OF_GROUPS_LOAD,
    category, query, limitNew, after,
});

/////////////////////////////////////////////////////////////////////
// Load more new groups

export interface ListOfGroupsFetchNewApiAction extends Action {
    readonly limit: number;
    readonly after: number;
}

export const FORUM_LIST_OF_GROUPS_FETCH_NEW_API_REQUEST = 'FORUM_LIST_OF_GROUPS_FETCH_NEW_API_REQUEST';

export interface ListOfGroupsFetchNewApiRequestAction extends ListOfGroupsFetchNewApiAction, APIRequestAction {
    readonly type: typeof FORUM_LIST_OF_GROUPS_FETCH_NEW_API_REQUEST;
}

export const FORUM_LIST_OF_GROUPS_FETCH_NEW_API_SUCCESS = 'FORUM_LIST_OF_GROUPS_FETCH_NEW_API_SUCCESS';

export interface ListOfGroupsFetchNewApiSuccessAction extends ListOfGroupsFetchNewApiAction, APISuccessAction {
    readonly type: typeof FORUM_LIST_OF_GROUPS_FETCH_NEW_API_SUCCESS;
    readonly hasMore: boolean;
}

export const FORUM_LIST_OF_GROUPS_FETCH_NEW_API_FAILURE = 'FORUM_LIST_OF_GROUPS_FETCH_NEW_API_FAILURE';

export interface ListOfGroupsFetchNewApiFailureAction extends ListOfGroupsFetchNewApiAction, APIFailureAction {
    readonly type: typeof FORUM_LIST_OF_GROUPS_FETCH_NEW_API_FAILURE;
}

export const listOfGroupsFetchNewApi = {
    request: (limit: number, after: number): ListOfGroupsFetchNewApiRequestAction => ({
        type: FORUM_LIST_OF_GROUPS_FETCH_NEW_API_REQUEST, limit, after,
    }),
    success: (limit: number, after: number, hasMore: boolean, response: any): ListOfGroupsFetchNewApiSuccessAction => ({
        type: FORUM_LIST_OF_GROUPS_FETCH_NEW_API_SUCCESS, limit, after, hasMore, response,
    }),
    failure: (limit: number, after: number, error: any): ListOfGroupsFetchNewApiFailureAction => ({
        type: FORUM_LIST_OF_GROUPS_FETCH_NEW_API_FAILURE, limit, after, error,
    }),
};

export const FORUM_LIST_OF_GROUPS_FETCH_NEW = 'FORUM_LIST_OF_GROUPS_FETCH_NEW';

export interface ListOfGroupsFetchNewAction extends ListOfGroupsFetchNewApiAction {
    readonly type: typeof FORUM_LIST_OF_GROUPS_FETCH_NEW;
}

export const listOfGroupsFetchNew = (limit: number, after: number): ListOfGroupsFetchNewAction => ({
    type: FORUM_LIST_OF_GROUPS_FETCH_NEW, limit, after,
});

/////////////////////////////////////////////////////////////////////
// Set selecting category

export const FORUM_LIST_OF_GROUPS_SET_SELECTING_CATEGORY = 'FORUM_LIST_OF_GROUPS_SET_SELECTING_CATEGORY';

export interface ListOfGroupsSetSelectingCategoryAction extends Action {
    readonly type: typeof FORUM_LIST_OF_GROUPS_SET_SELECTING_CATEGORY;
    readonly selecting: boolean;
}

export const listOfGroupsSetSelectingCategory = (selecting: boolean): ListOfGroupsSetSelectingCategoryAction => ({
    type: FORUM_LIST_OF_GROUPS_SET_SELECTING_CATEGORY,
    selecting,
});
